// pages/CasesScreen.js

import React, { useState, useEffect, useCallback } from 'react';
import { api } from '../api';
import { PlusCircle, MessageSquare } from 'lucide-react';
import toast from 'react-hot-toast';
import CreateCaseModal from '../components/support/CreateCaseModal';
import '../styles/CasesScreen.css';

// --- MODIFIED: Added setViewingCaseId to props
const CasesScreen = ({ user, setViewingCaseId }) => { 
    const [cases, setCases] = useState([]); //
    const [isLoading, setIsLoading] = useState(true); //
    const [isModalOpen, setIsModalOpen] = useState(false); //
    // const navigate = useNavigate(); // --- REMOVED

    const fetchData = useCallback(async () => {
        setIsLoading(true); //
        try {
            const casesData = await api.getCases(); //
            setCases(casesData); //
        } catch (error) {
            toast.error('Failed to load support cases.'); //
        } finally {
            setIsLoading(false); //
        }
    }, []); //

    useEffect(() => {
        fetchData(); //
    }, [fetchData]); //

    const handleCaseCreated = () => {
        setIsModalOpen(false); //
        fetchData(); // Refresh the list after a new case is created //
    };

    if (isLoading) {
        return <div className="placeholder-text">Loading cases...</div>; //
    }

    return (
        <div>
            {isModalOpen && ( //
                <CreateCaseModal 
                    user={user} //
                    onClose={() => setIsModalOpen(false)}  //
                    onCaseCreated={handleCaseCreated}  //
                />
            )}
            <div className="page-header">
                <h1 className="page-title">Support Cases</h1>
                <div className="page-header-actions">
                    <button onClick={() => setIsModalOpen(true)} className="action-button">
                        <PlusCircle size={18} />
                        <span>Create New Case</span>
                    </button>
                </div>
            </div>

            <div className="card">
                {cases.length > 0 ? ( //
                    <table className="data-table">
                        <thead>
                            <tr>
                                <th>Case ID</th>
                                <th>Subject</th>
                                <th>Property</th>
                                <th>Status</th>
                                <th>Priority</th>
                                <th>Last Updated</th>
                            </tr>
                        </thead>
                        <tbody>
                            {cases.map(caseItem => (
                                // --- MODIFIED: Replaced navigate() with setViewingCaseId()
                                <tr key={caseItem.id} onClick={() => setViewingCaseId(caseItem.id)} className="data-row">
                                    <td data-label="Case ID">#{caseItem.id}</td>
                                    <td data-label="Subject">{caseItem.subject}</td>
                                    <td data-label="Property">{caseItem.property_name}</td>
                                    <td data-label="Status"><span className={`status-badge status-${caseItem.status.toLowerCase()}`}>{caseItem.status}</span></td>
                                    <td data-label="Priority"><span className={`priority-badge priority-${caseItem.priority.toLowerCase()}`}>{caseItem.priority}</span></td>
                                    <td data-label="Last Updated">{new Date(caseItem.updated_at).toLocaleString()}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                ) : (
                    <div className="placeholder-text" style={{ padding: '2rem' }}>
                        <MessageSquare size={48} style={{ marginBottom: '1rem', color: '#cbd5e1' }} />
                        You have not created any support cases yet.
                    </div>
                )}
            </div>
        </div>
    );
};

export default CasesScreen;